import API from '../interceptors/Api';

export const getInstitutions = (params) => API.get('/institutions', {
  params,
});

export const getInstitutionsByLink = () => API.get('/institutions/links');

export const getInstitutionDetail = (id) => API.get(`/institutions/${id}`, {
  params: {
    showRelations: true,
  },
});
